import React from 'react'
import styles from './ProfileButton.scss'
import cx from 'classnames'
import {PopoverLinkMenu, PopoverLinkMenuItem as MenuItem} from 'common/styleguide/PopoverLinkMenu'
import {Icon} from 'common/LegacyIcon'
import {Icon as NewIcon} from 'common/Icon'
import {getCurrentUser, experimentEnabled} from 'lib/utils'
import {showModal} from 'lib/modalUtils'
import {CHANGE_LOCALE_MODAL} from 'common/modals/ChangeLocaleModal'

const currentUserFromConfig = getCurrentUser()

export class ProfileButton extends React.PureComponent {
  static defaultProps = {
    currentUser: currentUserFromConfig
  }

  constructor (props) {
    super(props)
    this.state = {
      showMenu: false
    }
  }

  showMenu = () => {
    this.setState({showMenu: true})
  }

  closeMenu = () => {
    this.setState({showMenu: false})
  }

  render (props) {
    const {currentUser, id: divId, currentLanguage} = this.props
    const {
      id: userId,
      accountLevel,
      highlightedPhotoId,
      numUnreadMessages,
      hasSubscription
    } = currentUser

    let profileImage = highlightedPhotoId ? `/photos/milli/${highlightedPhotoId}.jpg` : '/images/default-profile.jpg'

    // handle case where user is logged into organization account
    let isClub = false
    let isDefaultImage = false
    if (window.rwgps && window.rwgps.config && window.rwgps.config.club) {
      isClub = true
      profileImage = window.rwgps.config.club.logo
      isDefaultImage = /default/.test(profileImage)
    }

    const {showMenu} = this.state
    const hasUnread = numUnreadMessages > 0

    // /images/default-profile.jpg
    return (
      <div id={divId} className={styles.ProfileButton}>
        <a ref={r => { this._button = r }} className={cx(styles.profileButtonLink, hasUnread && styles.hasUnread, isClub && styles.clubLogo, isDefaultImage && styles.defaultImage)} onClick={this.showMenu}>
          <img src={profileImage} />
          {!showMenu && <Icon i='downChevron' className={styles.chevron} size={20} />}
          {showMenu && <Icon i='upChevron' className={styles.chevron} size={20} />}
        </a>
        {showMenu &&
          <PopoverLinkMenu
            insideMargin={false}
            placement='bottom'
            target={this._button}
            onRequestClose={this.closeMenu}>
            <MenuItem href={`/users/${userId}/`}>{isClub && 'Home'}{!isClub && 'Profile'}</MenuItem>
            {!isClub && <MenuItem href={`/users/${userId}/conversations`} className={cx(hasUnread && styles.hasUnreadListItem)}>Messages</MenuItem>}
            {!isClub && <MenuItem href='/settings/account'>Settings</MenuItem>}
            {!isClub && hasSubscription && <MenuItem href='/subscriptions/manage'>Manage Subscription</MenuItem>}
            {accountLevel < 1 && <MenuItem href='/choose_account'>Upgrade</MenuItem>}
            <MenuItem href='/help'>Help</MenuItem>
            <MenuItem href='/logout' id='logout-link'>Sign Out</MenuItem>
            <li className={styles.hr} />
            {experimentEnabled('localization') && <MenuItem onClick={() => showModal(CHANGE_LOCALE_MODAL)}><NewIcon i='ios-globe-outline' size={15} /> {currentLanguage}</MenuItem>}
          </PopoverLinkMenu>}
      </div>
    )
  }
}
